module.exports = __webpack_public_path__ + "static/media/krisha-chokshi.d38deea5.jpg";